export default "__VITE_ASSET__BNanNIzk__$_?format=webp__"